import styled from "styled-components";
import { borderRadius, fontSizes, lineHeights, spacing, typographyMixin } from "@magicbi/ui-library";

export const Wrap = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${borderRadius.xl};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface.primary};
`;

export const Rows = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const Row = styled.li`
  display: grid;
  grid-template-columns: 15rem minmax(0, 1fr) auto;
  align-items: center;
  column-gap: ${spacing[3]};
  padding: ${spacing[2]} ${spacing[4]};
  border-top: 1px solid ${({ theme }) => theme.colors.border.subtle};

  &:first-child {
    border-top: 0;
  }

  /* GAP(tint tokens): design uses a pale red / pale violet row tint */
  &[data-status="attention"] {
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  &[data-status="current"] {
    background: ${({ theme }) => theme.colors.background.tertiary};
  }
`;

export const Who = styled.span`
  display: flex;
  align-items: center;
  gap: ${spacing[2.5]};
  min-width: 0;
`;

export const Avatar = styled.span<{ $color?: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 1.375rem;
  height: 1.375rem;
  border-radius: ${borderRadius.md};
  overflow: hidden;
  ${typographyMixin("caption", 2)}
  font-size: 0.5625rem;
  background: ${({ $color, theme }) => $color ?? theme.colors.background.tertiary};
  color: ${({ $color, theme }) => ($color ? theme.colors.text.inverse : theme.colors.text.secondary)};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Label = styled.b`
  ${typographyMixin("body", 2)}
  font-size: ${fontSizes["13"]};
  line-height: ${lineHeights["20"]};
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Chips = styled.span`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing[1.5]};
  min-width: 0;
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  height: 1.75rem;
  padding: 0 ${spacing[2.5]};
  border-radius: ${borderRadius.full};
  border: 1px solid ${({ theme }) => theme.colors.border.stroke};
  background: ${({ theme }) => theme.colors.surface.primary};
  ${typographyMixin("caption", 3)}
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  &[data-invalid="true"] {
    border-color: ${({ theme }) => theme.colors.error.text};
    color: ${({ theme }) => theme.colors.error.text};
  }
`;

export const Status = styled.span`
  text-align: right;
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};

  &[data-error="true"] {
    color: ${({ theme }) => theme.colors.error.text};
  }

  &[data-warning="true"] {
    color: ${({ theme }) => theme.colors.warning.text};
  }
`;

export const Foot = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2.5]};
  padding: ${spacing[2.5]} ${spacing[3.5]};
  border-top: 1px solid ${({ theme }) => theme.colors.border.subtle};
  ${typographyMixin("caption", 4)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Summary = styled.span`
  flex: 1;
`;

export const ShowAll = styled.button`
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  ${typographyMixin("caption", 2)}
  color: ${({ theme }) => theme.colors.text.link};

  &:hover {
    text-decoration: underline;
  }
`;
